export class PurchaseOrderItemForDetails {
  customerName: string
  orderId: number

  constructor(customerName: string, orderId: number) {
    this.customerName = customerName
    this.orderId = orderId
  }
}
